import { PublicClientApplication, type Configuration } from '@azure/msal-browser';

/**
 * MSAL configuration using environment variables injected by Vite at build time.
 * cacheLocation: sessionStorage is more secure than localStorage for SPAs —
 * tokens are cleared when the browser tab closes, reducing the attack surface.
 */
const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID as string,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_AD_TENANT_ID as string}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
};

/**
 * Module-scope PublicClientApplication instance.
 * IMPORTANT: Must call msalInstance.initialize() before any use (MSAL v5 requirement).
 * See main.tsx bootstrap() for initialization.
 */
export const msalInstance = new PublicClientApplication(msalConfig);

/**
 * Scopes requested during login and token acquisition.
 * The API scope (audit.read) is used for every call, reads and writes. Write access is
 * authorized server-side by the Audit.Admin APP ROLE carried in this token's `roles`
 * claim — no additional scope is ever requested.
 */
export const loginRequest = {
  scopes: [import.meta.env.VITE_API_SCOPE as string],
};
